import React from 'react';
import { Link } from 'react-router-dom';
import { studentGoals, submissions } from '../utils/mockData';
import { CheckCircleIcon, AlertCircleIcon, UserIcon, BarChart3Icon } from 'lucide-react';
const TeacherDashboard: React.FC = () => {
  // Get pending submissions
  const pendingSubmissions = submissions.filter(sub => sub.status === 'pending');
  // Count total students, goals, and approved submissions
  const uniqueStudentIds = new Set(studentGoals.map(goal => goal.studentId));
  const totalStudents = uniqueStudentIds.size;
  const totalGoals = studentGoals.length;
  const approvedSubmissions = submissions.filter(sub => sub.status === 'approved').length;
  return <div className="max-w-5xl mx-auto" data-id="element-1056">
      <h1 className="text-2xl font-bold text-gray-800 mb-6" data-id="element-1057">教师管理控制台</h1>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-1058">
        <div className="bg-white rounded-lg shadow p-6" data-id="element-1059">
          <div className="flex items-center mb-4" data-id="element-1060">
            <div className="p-3 bg-blue-100 rounded-full mr-4" data-id="element-1061">
              <UserIcon size={24} className="text-blue-600" data-id="element-1062" />
            </div>
            <div data-id="element-1063">
              <p className="text-sm text-gray-500" data-id="element-1064">学生总数</p>
              <h3 className="text-2xl font-bold text-gray-800" data-id="element-1065">
                {totalStudents}
              </h3>
            </div>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow p-6" data-id="element-1066">
          <div className="flex items-center mb-4" data-id="element-1067">
            <div className="p-3 bg-green-100 rounded-full mr-4" data-id="element-1068">
              <BarChart3Icon size={24} className="text-green-600" data-id="element-1069" />
            </div>
            <div data-id="element-1070">
              <p className="text-sm text-gray-500" data-id="element-1071">学习目标总数</p>
              <h3 className="text-2xl font-bold text-gray-800" data-id="element-1072">{totalGoals}</h3>
            </div>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow p-6" data-id="element-1073">
          <div className="flex items-center mb-4" data-id="element-1074">
            <div className="p-3 bg-purple-100 rounded-full mr-4" data-id="element-1075">
              <CheckCircleIcon size={24} className="text-purple-600" data-id="element-1076" />
            </div>
            <div data-id="element-1077">
              <p className="text-sm text-gray-500" data-id="element-1078">已完成目标数</p>
              <h3 className="text-2xl font-bold text-gray-800" data-id="element-1079">
                {approvedSubmissions}
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white rounded-lg shadow p-6 mb-8" data-id="element-1080">
        <div className="flex justify-between items-center mb-4" data-id="element-1081">
          <h2 className="text-xl font-medium text-gray-800 flex items-center" data-id="element-1082">
            <AlertCircleIcon size={20} className="text-yellow-500 mr-2" data-id="element-1083" />
            待审核的提交 ({pendingSubmissions.length})
          </h2>
          <Link to="/review-submissions" className="text-blue-600 hover:text-blue-800 text-sm font-medium" data-id="element-1084">
            查看全部
          </Link>
        </div>
        {pendingSubmissions.length > 0 ? <div className="space-y-4" data-id="element-1085">
            {pendingSubmissions.slice(0, 3).map(submission => {
          const goal = studentGoals.find(g => g.id === submission.goalId);
          return <div key={submission.id} className="border border-gray-200 rounded-lg p-4" data-id="element-1086">
                  <div className="flex items-start" data-id="element-1087">
                    <div className="flex-1" data-id="element-1088">
                      <div className="flex items-center" data-id="element-1089">
                        <h3 className="font-medium text-gray-800" data-id="element-1090">
                          {goal?.title}
                        </h3>
                        <span className="ml-2 bg-yellow-100 text-yellow-800 text-xs px-2 py-1 rounded-full" data-id="element-1091">
                          待审核
                        </span>
                      </div>
                      <p className="text-sm text-gray-500 mt-1" data-id="element-1092">
                        学生: {submission.studentName} | 提交时间:{' '}
                        {submission.submittedAt}
                      </p>
                      <p className="text-sm text-gray-600 mt-2" data-id="element-1093">
                        {submission.content}
                      </p>
                      {submission.evidence && <div className="mt-2" data-id="element-1094">
                          <img src={submission.evidence} alt="完成证明" className="h-20 w-auto rounded-md" data-id="element-1095" />
                        </div>}
                    </div>
                    <div className="ml-4 flex space-x-2" data-id="element-1096">
                      <button className="bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700 transition-colors text-sm" data-id="element-1097">
                        通过
                      </button>
                      <button className="bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700 transition-colors text-sm" data-id="element-1098">
                        未通过
                      </button>
                    </div>
                  </div>
                </div>;
        })}
          </div> : <p className="text-gray-500 text-center py-4" data-id="element-1099">暂无待审核的提交</p>}
      </div>
      <div className="bg-white rounded-lg shadow p-6" data-id="element-1100">
        <h2 className="text-xl font-medium text-gray-800 mb-4" data-id="element-1101">
          最近的学习目标
        </h2>
        <div className="overflow-x-auto" data-id="element-1102">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-1103">
            <thead data-id="element-1104">
              <tr data-id="element-1105">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1106">
                  学生
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1107">
                  目标
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1108">
                  截止日期
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1109">
                  状态
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-1110">
              {studentGoals.slice(0, 5).map(goal => <tr key={goal.id} data-id="element-1111">
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1112">
                    <div className="text-sm font-medium text-gray-800" data-id="element-1113">
                      {goal.studentName}
                    </div>
                  </td>
                  <td className="px-6 py-4" data-id="element-1114">
                    <div className="text-sm text-gray-800" data-id="element-1115">{goal.title}</div>
                    <div className="text-xs text-gray-500" data-id="element-1116">
                      {goal.description.substring(0, 50)}...
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1117">
                    {goal.deadline}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1118">
                    {goal.status === 'pending' && <span className="bg-yellow-100 text-yellow-800 text-xs px-2 py-1 rounded-full" data-id="element-1119">
                        未提交
                      </span>}
                    {goal.status === 'submitted' && <span className="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full" data-id="element-1120">
                        待审核
                      </span>}
                    {goal.status === 'approved' && <span className="bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full" data-id="element-1121">
                        已完成
                      </span>}
                    {goal.status === 'rejected' && <span className="bg-red-100 text-red-800 text-xs px-2 py-1 rounded-full" data-id="element-1122">
                        未通过
                      </span>}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
};
export default TeacherDashboard;